import copy from 'copy-to-clipboard';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import _values from 'lodash/values';
import { number, mixed } from 'yup';
import { isValid, isBefore, addDays, isAfter } from 'date-fns';
import _find from 'lodash/find';
import _groupBy from 'lodash/groupBy';
import _isEqual from 'lodash/isEqual';
import _isObject from 'lodash/isObject';
import _transform from 'lodash/transform';
import _includes from 'lodash/includes';
import _isFinite from 'lodash/isFinite';
import _isNull from 'lodash/isNull';
import _size from 'lodash/size';
import _endsWith from 'lodash/endsWith';
import _isString from 'lodash/isString';
import _toLower from 'lodash/toLower';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _memoize from 'lodash/memoize';
import _padStart from 'lodash/padStart';
import _replace from 'lodash/replace';
import _split from 'lodash/split';
import _startsWith from 'lodash/startsWith';
import _toUpper from 'lodash/toUpper';
import Big from 'bignumber.js';
import _isNaN from 'lodash/isNaN';
import _omit from 'lodash/omit';
import _slice from 'lodash/slice';
/* eslint-disable import/prefer-default-export */

var copyToClipboard = function copyToClipboard(value) {
  return copy(value);
}; // eslint-disable-next-line import/prefer-default-export


var convertHexToRGBA = function convertHexToRGBA(hexCode, opacity) {
  var hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
  }

  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity, ")");
};

var convertRGBToRGBA = function convertRGBToRGBA(rgb, a) {
  return rgb.replace(')', ", ".concat(a, ")"));
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getValue = function getValue(_ref) {
  var _ref$mapping = _ref.mapping,
      mapping = _ref$mapping === void 0 ? {} : _ref$mapping,
      _ref$customMapping = _ref.customMapping,
      customMapping = _ref$customMapping === void 0 ? {} : _ref$customMapping,
      data = _ref.data;
  return function (key) {
    var shouldFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var defaultValue = _get(mapping, [key, 'defaultValue']);

    var defaultFormat = _get(mapping, "".concat(key, ".format"));

    var customFormat = _get(customMapping, "".concat(key, ".format"));

    var selector = _get(customMapping, "".concat(key, ".selector"), key);

    var value = _get(data, selector, defaultValue);

    if (!shouldFormat || !customFormat && !defaultFormat) {
      return value;
    }

    if (customFormat) {
      return customFormat(value, selector, data);
    }

    return defaultFormat(value);
  };
};

var getMappedKey = function getMappedKey(key) {
  var customMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var customKey = _get(customMapping, [key, 'selector']);

  return customKey || key;
};

var getMappingForKey = function getMappingForKey() {
  var customMapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (key) {
    var customKey = _get(customMapping, [key, 'selector']);

    return customKey || key;
  };
};

var getVisibleColumns = function getVisibleColumns(columns) {
  var customMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _filter(columns, function (_ref2) {
    var key = _ref2.key;
    return !_get(customMapping, [key, 'hidden'], false);
  });
};

var getOrderedColumns = function getOrderedColumns(columns) {
  var customMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var hasOrdering = _values(customMapping).some(function (row) {
    return !Number.isNaN(row.index);
  });

  if (!hasOrdering) {
    return columns;
  }

  var indexedColumns = _map(columns, function (column) {
    return _objectSpread(_objectSpread({}, column), {}, {
      index: _get(customMapping, [column.key, 'index'], null)
    });
  });

  var sortedColumns = _sortBy(indexedColumns, ['index', 'asc']);

  return sortedColumns;
};

var getMappedColumns = function getMappedColumns(columns) {
  var customMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var visibleColumns = getVisibleColumns(columns, customMapping);
  var orderedColumns = getOrderedColumns(visibleColumns, customMapping);
  return orderedColumns;
};
/* eslint-disable import/prefer-default-export */

/**
 * applies a TimeZone Offset to an UTC date
 *
 * @param {*} mts date to translate
 * @param {*} offset hours of difference from UTC
 */


var applyTimeZoneOffset = function applyTimeZoneOffset(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var localOffset = date.getTimezoneOffset();
  var delta = (localOffset + offset) * 60000;
  return new Date(date.getTime() + delta);
};

var snapshot = function snapshot() {
  var rawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var adapter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var data = _map(rawData, function (row) {
    return adapter(row, opts);
  });

  var dataObj = {};
  data.forEach(function (row) {
    var id = row.id;
    dataObj[id] = row;
  });
  return dataObj;
};
/**
 * returns a series of prices grouped by the current psnap levels
 * useful for assigning alerts/orders to psnap price levels in books
 *
 * @param {Object} args
 * @param {Array<Number>} args.psnap psnap book price levels
 * @param {Array<Number|Object>} args.list prices to show in the list
 * @param {String|Bool} args.prop name of the property to check in case it's not an array of numbers
 * @param {Bool} args.isBid reverses the order of the sorting, if true
 * @returns {Object} key: psnap price level, value: array of prices at that level
 *
 * ex.
 * const psnap = [ 1, 2, 3, 4, 5, 10 ]
 * const prices = [ 1.1, 1.2, 1.3, 4, 1000 ]
 * groupPrices({ psnap, prices })
 * returns {
 *   "2": [ 1.1, 1.2, 1.3 ],
 *   "4": [ 4 ],
 *   "10": [ 1000 ]
 * }
 */


var groupPrices = function groupPrices() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _args$psnap = args.psnap,
      psnap = _args$psnap === void 0 ? [] : _args$psnap,
      _args$list = args.list,
      list = _args$list === void 0 ? [] : _args$list,
      _args$prop = args.prop,
      prop = _args$prop === void 0 ? false : _args$prop,
      _args$isBid = args.isBid,
      isBid = _args$isBid === void 0 ? false : _args$isBid;

  var search = function search(el) {
    return _find(psnap, function (curr, index) {
      var price = prop ? _get(el, [prop]) : el;
      var extremum = isBid ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
      var prev = psnap[index - 1] || extremum;
      return isBid ? +curr <= +price && +price < +prev : +curr >= +price && +price > +prev;
    });
  };

  return _groupBy(list, search);
};

var difference = function difference(object, base) {
  var changes = function changes(o, b) {
    return _transform(o, function (result, value, key) {
      if (!_isEqual(value, b[key])) {
        // eslint-disable-next-line no-param-reassign
        result[key] = _isObject(value) && _isObject(b[key]) ? changes(value, b[key]) : value;
      }
    });
  };

  return changes(object, base);
};

var isValidDate = function isValidDate(date) {
  return isValid(new Date(date));
};

var isBeforeMinDate = function isBeforeMinDate(date, minDays) {
  return isBefore(new Date(date), addDays(new Date(), minDays));
};

var isAfterMaxDate = function isAfterMaxDate(date, maxDays) {
  return isAfter(new Date(date), addDays(new Date(), maxDays));
};

var isValidTifDate = function isValidTifDate(createError, t, minDays, maxDays) {
  return function (date) {
    if (isBeforeMinDate(date, minDays)) {
      return createError({
        message: t('error:must_be_after_min_date')
      });
    }

    if (isAfterMaxDate(date, maxDays)) {
      return createError({
        message: t('error:must_be_before_max_date')
      });
    }

    return true;
  };
};

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getDecimal(num) {
  var asString = "".concat(num);
  return _includes(asString, 'e') ? parseInt(asString.split('e-')[1], 10) : _size(asString.split('.')[1] || '');
}

var NUMBER_FORMAT_MAP = {};
var INTL_FRACTION_DIGITS_MAX_VAL = 20;

var formatNumber = function formatNumber() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var number = args.number,
      realDecimals = args.decimals,
      significantFigures = args.significantFigures,
      _args$useGrouping = args.useGrouping,
      useGrouping = _args$useGrouping === void 0 ? false : _args$useGrouping,
      _args$short = args["short"],
      _short = _args$short === void 0 ? false : _args$short; // use decimals for numbers less than 1


  var decimals = _short && number !== 0 && Math.abs(number) < 1 && _isFinite(significantFigures) ? significantFigures : realDecimals;
  var options = {
    useGrouping: useGrouping
  };

  if (_isFinite(decimals) && decimals >= 0) {
    options.minimumFractionDigits = Math.min(decimals, INTL_FRACTION_DIGITS_MAX_VAL);
    options.maximumFractionDigits = Math.min(decimals, INTL_FRACTION_DIGITS_MAX_VAL);
  } else if (_isFinite(significantFigures)) {
    var sigFig = number === 0 ? 3 : significantFigures;
    options.minimumSignificantDigits = sigFig;
    options.maximumSignificantDigits = sigFig;
  }

  if (_short) {
    options.notation = 'compact';
    options.compactDisplay = 'short';
  }

  var key = "".concat(options.useGrouping, "-").concat(options.minimumFractionDigits, "-") + "".concat(options.maximumFractionDigits, "-").concat(options.minimumSignificantDigits, "-") + "".concat(options.maximumSignificantDigits, "-").concat(_short);
  var numberFormatter = NUMBER_FORMAT_MAP[key];

  if (!numberFormatter) {
    numberFormatter = new Intl.NumberFormat('EN-US', options);
    NUMBER_FORMAT_MAP[key] = numberFormatter;
  }

  var res = numberFormatter.format(number);
  var isSmallValue = number && Math.abs(number) < 1 && options.maximumSignificantDigits;

  if (isSmallValue && res.replace('-', '').length - 2 > options.maximumSignificantDigits) {
    // replace trailing zeors for values if they are longer than sigfig
    // for sigfig 4 0.0003000 -> 0.0003
    // for sigfig 4 0.3000 -> 0.3000
    return res.replace(/0+$/, '');
  }

  return res;
};

var getNumberOfDecimalsByPrice = function getNumberOfDecimalsByPrice(price) {
  var significantDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return Math.max(0, significantDigits - 1 - Math.floor(Math.log10(price)));
};

var getNumberOfDecimals = function getNumberOfDecimals(price) {
  return Math.min(6, getNumberOfDecimalsByPrice(price));
};

var formatPrice = function formatPrice(price) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(_objectSpread$1({
    number: price,
    significantFigures: 5,
    decimals: opts.minDecimals ? Math.max(opts.minDecimals, getNumberOfDecimals(price)) : getNumberOfDecimals(price),
    useGrouping: true
  }, opts));
};

var formatVolume = function formatVolume(volume) {
  return formatNumber({
    number: volume,
    decimals: 0,
    useGrouping: true
  });
};

var formatVolumePercentChange = function formatVolumePercentChange(volumeChange) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var valueString = formatNumber({
    number: Math.abs(volumeChange * 100),
    decimals: decimals
  });
  var sign = volumeChange < 0 ? '-' : '';
  return "".concat(sign).concat(valueString, "%");
};

var formatTotal = function formatTotal(total) {
  return formatNumber({
    number: total,
    decimals: 4,
    useGrouping: true
  });
};

var checkDecimals = function checkDecimals(maxDecimals, createError, t, fieldLabel) {
  return function (number) {
    if (_isFinite(number)) {
      var exponent = 1;
      var decimals = 0;
      var allowedDecimals = _isNull(maxDecimals) ? getNumberOfDecimalsByPrice(number) : maxDecimals; // @TODO this is not very readable

      while (Math.round(number * exponent) / exponent !== number) {
        exponent *= 10; // eslint-disable-next-line no-plusplus

        if (++decimals > allowedDecimals) {
          if (allowedDecimals === 0) {
            return createError({
              message: t('error:no_decimals', {
                fieldLabel: fieldLabel
              })
            });
          }

          return createError({
            message: t('error:max_decimals', {
              fieldLabel: fieldLabel,
              allowedDecimals: allowedDecimals
            })
          });
        }
      }
    }

    return true;
  };
};
/* eslint-disable import/prefer-default-export */


var numberToFiatString = function numberToFiatString(value) {
  var opts = value < 10000 ? {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  } : {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  };
  return value.toLocaleString('EN-US', opts);
};

var getDigits = function getDigits(value) {
  var number = Number(value);
  var string = number.toString();
  var hasExponent = string.indexOf('e') !== -1; // is the number written using the scientific notation

  if (hasExponent) {
    var exponent = string.split('e')[1].substring(1);
    return parseInt(exponent, 10) + 1;
  }

  return number.toString().length;
};

var NUMBER_INPUT_MAX_LENGTH = 20;

var isNotInfinite = function isNotInfinite(number) {
  return !number || Number.isFinite(number);
};

var isValidLength = function isValidLength(value) {
  return getDigits(value) <= NUMBER_INPUT_MAX_LENGTH;
};

var requiredPositiveNumber = function requiredPositiveNumber(t, fieldLabel) {
  return number().typeError(t('error:must_be_number', {
    fieldLabel: fieldLabel
  })).required(t('error:required', {
    fieldLabel: fieldLabel
  })).positive(t('error:must_be_positive', {
    fieldLabel: fieldLabel
  })).test('not_infinite', t('error:must_be_number', {
    fieldLabel: fieldLabel
  }), isNotInfinite);
};

var validateLength = function validateLength(t, fieldLabel) {
  return number().test('length', t('error:max_length', {
    fieldLabel: fieldLabel,
    maxLength: NUMBER_INPUT_MAX_LENGTH
  }), isValidLength);
};

var validateDecimals = function validateDecimals(maxDecimals, t, fieldLabel) {
  return number().test({
    name: 'validate-decimals',
    test: function test(value) {
      return checkDecimals(maxDecimals, this.createError, t, fieldLabel)(value);
    }
  });
};

var requiredDate = function requiredDate(t, fieldLabel) {
  return mixed().typeError(t('error:required', {
    fieldLabel: fieldLabel
  })).required(t('error:required', {
    fieldLabel: fieldLabel
  })).test('valid_date', t('error:must_be_date'), isValidDate);
};

var validateExpiryDate = function validateExpiryDate(t, minDays, maxDays) {
  return mixed().test({
    name: 'validate-expiry-date',
    test: function test(value) {
      return isValidTifDate(this.createError, t, minDays, maxDays)(value);
    }
  });
};

var PAIR_URL_SEPARATOR = ':';
var PAIR_OUTPUT_SEPARATOR = '/';
var defaultBaseCcy = process.env.REACT_APP_UFX_DEFAULT_BASE_CCY || 'BTC';
var defaultQuoteCcy = process.env.REACT_APP_UFX_DEFAULT_BASE_CCY || 'USD';
var defaultUrlPair = defaultBaseCcy + PAIR_URL_SEPARATOR + defaultQuoteCcy;
var defaultBaseCcyPaper = process.env.REACT_APP_UFX_DEFAULT_BASE_CCY || 'TESTBTC';
var defaultQuoteCcyPaper = process.env.REACT_APP_UFX_DEFAULT_QUOTE_CCY || 'TESTUSD';
var defaultUrlPairPaper = defaultBaseCcyPaper + PAIR_URL_SEPARATOR + defaultQuoteCcyPaper;
var loggerLevels = process.env.REACT_APP_UFX_LOGGER_LEVELS ? JSON.parse(process.env.REACT_APP_UFX_LOGGER_LEVELS) : ['error'];
var DERIVATIVE_SPOT_REGEX = /F[A-Z]{0,1}[0-9]{1,9}/i;
var PERPETUAL_SWAPS_REGEX = /[A-Z]{2,}F[A-Z]{0,1}[0-9]{1,3}/;
var FUTURES_REGEX = /[A-Z]{2,}F([A-Z]{1})([0-9]{1,9})/;
var TRADING_PREFIX = 't';
var FUNDING_PREFIX = 'f'; // obtains a pair from a given symbol without the prefix
// ex. tBTCUSD -> BTCUSD
// ex. fUSD -> USD
// it just removes the first letter if it's a "t" or "f"

var removePrefix = function removePrefix() {
  var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!symbol) {
    return '';
  }

  var s = symbol.toString().charAt(0);
  return s === TRADING_PREFIX || s === FUNDING_PREFIX ? _toUpper(symbol.substring(1)) : _toUpper(symbol);
}; // returns true if symbol is a valid trading or derivative pair


var isPair = function isPair(symbol) {
  var s = _size(removePrefix(symbol));

  if (s === 6) {
    return true;
  }

  if (s > 6) {
    return _includes(symbol, PAIR_OUTPUT_SEPARATOR) || _includes(symbol, PAIR_URL_SEPARATOR);
  }

  return false;
};

var isPerpetualSwapCcy = function isPerpetualSwapCcy() {
  var ccy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return PERPETUAL_SWAPS_REGEX.test(ccy);
};

var isFutureCcy = function isFutureCcy() {
  var ccy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return FUTURES_REGEX.test(ccy);
}; // last two chars must be "F" followed by a number


var isDerivativeCcy = function isDerivativeCcy() {
  var ccy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isPerpetualSwapCcy(ccy) || isFutureCcy(ccy);
}; // converts derivative ccy to usual, if optional `replace` is not false
// USDF0 -> USD


var derivativeToCcy = function derivativeToCcy() {
  var ccy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return replace ? _replace(ccy, DERIVATIVE_SPOT_REGEX, '') : ccy;
};

var buildPair = function buildPair(from, to) {
  var isDerivPair = isDerivativeCcy(from) && isDerivativeCcy(to);
  var first = !isDerivPair && isDerivativeCcy(from) ? derivativeToCcy(from) : from;
  var second = !isDerivPair && isDerivativeCcy(to) ? derivativeToCcy(to) : to;
  var separator = _size(first) > 3 || _size(second) > 3 ? PAIR_URL_SEPARATOR : '';
  return "t".concat(first).concat(separator).concat(second);
}; // returns the symbols present in a pair
// it supports the following formats:
// - <any>/<any>
// - t<any>/<any>
// - f<any>
// - YYY/ZZZ
// - tYYY/ZZZ
// - fYYY


var getSymbols = _memoize(function () {
  var pair = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (_startsWith(pair, FUNDING_PREFIX)) {
    return [pair.substring(1), ''];
  }

  var input = _startsWith(pair, TRADING_PREFIX) ? pair.substring(1) : pair;

  if (input.length > 6) {
    return _split(input, /\/|:/, 2);
  }

  return [input.slice(0, 3), input.slice(3, 6)];
}); // first symbol of a pair
// it supports pairs of API v2
// ex. tBTCUSD


var firstInPair = function firstInPair(pair, uppercase) {
  var _getSymbols = getSymbols(pair),
      _getSymbols2 = _slicedToArray(_getSymbols, 1),
      _getSymbols2$ = _getSymbols2[0],
      first = _getSymbols2$ === void 0 ? '-' : _getSymbols2$;

  return uppercase ? _toUpper(first) : _toLower(first);
}; // last symbol of a pair
// it supports new pairs of API v2
// ex. tBTCUSD


var lastInPair = function lastInPair(pair, uppercase) {
  var _getSymbols3 = getSymbols(pair),
      _getSymbols4 = _slicedToArray(_getSymbols3, 2),
      _getSymbols4$ = _getSymbols4[1],
      second = _getSymbols4$ === void 0 ? '-' : _getSymbols4$;

  return uppercase ? _toUpper(second) : _toLower(second);
};

var startsWithAPrefix = function startsWithAPrefix(str) {
  return _startsWith(str, TRADING_PREFIX) || _startsWith(str, FUNDING_PREFIX);
};

var getPairParts = function getPairParts(pair) {
  return [firstInPair(pair, true), lastInPair(pair, true)];
};

var startsWithFundingPrefix = function startsWithFundingPrefix(symbol) {
  return _startsWith(symbol, FUNDING_PREFIX);
};

var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * Pads the number in two positions
 *
 * @param value {Number}
 * @returns {String}
 *
 * ex. 1 -> 01
 * ex. 99 -> 99
 */


var pad2 = function pad2(value) {
  return _padStart(value, 2, '0');
};

var DECIMALS_CRYPTO = 8;
var DECIMALS_FIAT = 2;
var fiatCcys = ['USD', 'EUR', 'JPY', 'HKD', 'GBP', 'CHF'];

var isFiat = function isFiat(symbol) {
  return _includes(fiatCcys, symbol);
};

var isTether = function isTether(symbol) {
  return _endsWith(_toLower(symbol), 't');
};

var urlPair = function urlPair(pair) {
  if (!_isString(pair)) {
    return '';
  }

  return "".concat(firstInPair(pair, true)).concat(PAIR_URL_SEPARATOR).concat(lastInPair(pair, true));
};

var convertToUrlPair = function convertToUrlPair(baseCcy, quoteCcy) {
  return "".concat(baseCcy).concat(PAIR_URL_SEPARATOR).concat(quoteCcy);
};

var getDecimalsForSymbol = function getDecimalsForSymbol(symbol) {
  if (isTether(symbol) && _toLower(symbol) !== 'xaut') {
    return DECIMALS_FIAT;
  }

  return isFiat(symbol) ? DECIMALS_FIAT : DECIMALS_CRYPTO;
};
/* eslint-disable import/prefer-default-export */

/**
 * Smartly set the precision (decimal) on a value based off of the significant
 * digit maximum. For example, calling with 3.34 when the max sig figs allowed
 * is 5 would return '3.3400', the representation number of decimals IF they
 * weren't zeros.
 *
 * @param {number} n
 * @param {number} maxSigs - default 5
 * @return {string} str
 */


var SIG_FIGS = 5;

var setSigFig = function setSigFig() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var maxSigs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIG_FIGS;
  var n = +number;

  if (!_isFinite(n)) {
    return number;
  }

  var value = n.toPrecision(maxSigs);
  return value.match(/e/) ? new Big(value).toString(10) : value;
};
/**
 * Decimal adjustment of a number.
 *
 * @param {String}  type  The type of adjustment.
 * @param {Number}  number The value.
 * @param {Integer} e   The exponent (the 10 logarithm of the adjustment base).
 * @returns {Number} The adjusted value.
 */


var decimalAdjust = function decimalAdjust(type, num, e) {
  // If the exp is undefined or zero...
  var value = +num;
  var exp = +e;

  if (typeof e === 'undefined' || exp === 0) {
    return Math[type](num);
  } // If the value is not a number or the exp is not an integer...


  if (_isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  } // Shift


  value = value.toString().split('e');
  value = Math[type](+"".concat(value[0], "e").concat(value[1] ? +value[1] - exp : -exp)); // Shift back

  value = value.toString().split('e');
  return +"".concat(value[0], "e").concat(value[1] ? +value[1] + exp : exp);
};
/**
 * Rounds down to specified number of decimals, and adds the minimum number of
 * zeros to ensure that a set of numbers passed through this function will
 * all have the same number of decimals.
 *
 * @param {number} num
 * @param {number} prec
 * @return {string} str
 */


var precision = function precision(num) {
  var prec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (_isNaN(num) || _isNaN(prec)) {
    return '';
  }

  var type = num > 0 ? 'floor' : 'ceil';
  var result = decimalAdjust(type, num, -prec);
  result = String(result.toFixed(prec)); // Fix if we have 'e notation'

  if (result.match(/e(-\d+)/)) {
    var base = result.match(/(\d+.?\d*)e/)[1];
    var exp = result.match(/e(-\d+)/)[1];
    var numZeros = Math.abs(exp);
    result = Array(numZeros).join('0') + base.replace(/\./, '');
    result = result.slice(0, prec);
    return "0.".concat(result);
  }

  if (!result.match(/\./) && prec <= 0) {
    return result;
  }

  if (!result.match(/\./)) {
    return "".concat(result, ".").concat(Array(prec + 1).join('0'));
  }

  if (result.split('.')[1].length < prec) {
    var zerosToAdd = prec - result.split('.')[1].length;
    return "".concat(result).concat(Array(zerosToAdd + 1).join('0'));
  }

  return result;
};
/* eslint-disable import/prefer-default-export */


var LOGGER_LEVEL = {
  LOG: 'log',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
};
var logger = {
  log: function log() {
    if (_includes(loggerLevels, LOGGER_LEVEL.LOG)) {
      var _console; // eslint-disable-next-line no-console


      (_console = console).log.apply(_console, arguments);
    }
  },
  debug: function debug() {
    if (_includes(loggerLevels, LOGGER_LEVEL.DEBUG)) {
      var _console2; // eslint-disable-next-line no-console


      (_console2 = console).debug.apply(_console2, arguments);
    }
  },
  info: function info() {
    if (_includes(loggerLevels, LOGGER_LEVEL.INFO)) {
      var _console3; // eslint-disable-next-line no-console


      (_console3 = console).info.apply(_console3, arguments);
    }
  },
  warn: function warn() {
    if (_includes(loggerLevels, LOGGER_LEVEL.WARN)) {
      var _console4; // eslint-disable-next-line no-console


      (_console4 = console).warn.apply(_console4, arguments);
    }
  },
  error: function error() {
    if (_includes(loggerLevels, LOGGER_LEVEL.ERROR)) {
      var _console5; // eslint-disable-next-line no-console


      (_console5 = console).error.apply(_console5, arguments);
    }
  }
};
/* eslint-disable import/prefer-default-export */

/**
 * returns the max newest elements of the object
 * based on the "mts" property
 *
 * @param {Object} data source object
 * @param {Number} max number of allowed elements
 * @param {String} field name of the property to sort
 * @return {Object}
 */

var removeOldest = function removeOldest() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 20 : _ref$max,
      _ref$field = _ref.field,
      field = _ref$field === void 0 ? 'mts' : _ref$field;

  var list = Object.values(data);

  var sortedList = _sortBy(list, field);

  var slicedList = _slice(sortedList, 0, max);

  return _omit(data, _map(slicedList, 'id'));
};

var isDevelopmentMode = process.env.NODE_ENV === 'development';
var PLATFORM_SETTINGS = {
  AMOUNT_SIG_FIGS: 5,
  AMOUNT_DECIMALS: 8,
  PRICE_SIG_FIGS: 5,
  PRICE_DECIMALS: 4
};
var book = {
  UPDATE_COOLDOWN_MS: 1000,
  // 1 sec
  MAX_PRECISION: 4,
  MIN_ZOOM: 20,
  DEFAULT_ZOOM: 100,
  MAX_ZOOM: 200
};
export { DECIMALS_CRYPTO, DECIMALS_FIAT, FUNDING_PREFIX, PAIR_OUTPUT_SEPARATOR, PAIR_URL_SEPARATOR, PLATFORM_SETTINGS, TRADING_PREFIX, applyTimeZoneOffset, book, buildPair, capitalize, checkDecimals, convertHexToRGBA, convertRGBToRGBA, convertToUrlPair, copyToClipboard, decimalAdjust, defaultBaseCcy, defaultBaseCcyPaper, defaultQuoteCcy, defaultQuoteCcyPaper, defaultUrlPair, defaultUrlPairPaper, derivativeToCcy, difference, fiatCcys, firstInPair, formatNumber, formatPrice, formatTotal, formatVolume, formatVolumePercentChange, getDecimal, getDecimalsForSymbol, getDigits, getMappedColumns, getMappedKey, getMappingForKey, getNumberOfDecimals, getNumberOfDecimalsByPrice, getOrderedColumns, getPairParts, getSymbols, getValue, getVisibleColumns, groupPrices, isDerivativeCcy, isDevelopmentMode, isFiat, isFutureCcy, isNotInfinite, isPair, isPerpetualSwapCcy, isTether, isValidDate, isValidLength, isValidTifDate, lastInPair, logger, loggerLevels, numberToFiatString, pad2, precision, removeOldest, removePrefix, requiredDate, requiredPositiveNumber, setSigFig, snapshot, startsWithAPrefix, startsWithFundingPrefix, urlPair, validateDecimals, validateExpiryDate, validateLength };